import Controller from "csi/action/Controller";
import { browserStore } from "csi/state/rootStore";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";

const AbortUploadController = declare(Controller, {
	/**
     * @override
     */
	toWriter(): void {
		this.m_writer.changeNode(this.m_urlNode).deleteAttribute(this.m_action.heading.m_id + ".Status");
	},

	/**
     * @override
     */
	process(): void {
		const abortController = browserStore.getFileUploadController(this.m_urlNode, this.m_action.heading.m_id);
		if (abortController) {
			abortController.abort();
			this.inherited(arguments);
		} else {
			this.displayErrorDialog({
				materialIcon: MessageDialog.ICON_WARNING,
				suffix: "_ErrorAlreadyUploaded",
				title: this.getTitle(),
			});
		}
	},
});

export = AbortUploadController;
